import QuestPage from "./QuestPage";

export default function Missions() {
  return <QuestPage groupKey="missions" />;
}
